import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=dc7556e6&"
import script from "./IssueList.vue?vue&type=script&lang=js&"
export * from "./IssueList.vue?vue&type=script&lang=js&"
import style0 from "./IssueList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports